import React from 'react';
import Search from './Search';
import SponsorInfoTab from './sponsorInfo/SponsorInfoTab';
import SponsorUsersTab from './users/SponsorUsersTab';
import SponsorHistoryTab from './sponsorHistory/SponsorHistoryTab';
import DiscountCodesHistoryTab from './discountCodesHistory/DiscountCodesHistoryTab';
import NotificationsTab from './notifications/NotificationsTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'

class SponsorSetup extends React.Component {

    render() {
        let opts = {
            setupKey: "sponsorSetup",
            title: "Member Search",
            description: "Create, modify, and remove members",
            addNewTitle: "Add new member",
            helpKey: Help.sponsorSetupHelpKey,
            addPrivilege: false,
            enableColumnSettings: true,
            recentType: "sponsor",
            sortField: "sponsorName",
			sortDirection: "ASC",
            list: {
                url: API.Sponsor.url('/sponsorSetup/search'),
                rowKey: "sponsorId",
                columns: [
                    { key: 'sponsorId', name: 'CM ID', sortable: true, width: 70 },
                    { key: 'sponsorName', name: 'Company Name', sortable: true },
                    { key: 'address', name: 'Address', sortable: true },
                    { key: 'website', name: 'Website', formatter: Formatter.ExternalLink, getRowMetaData: (row) => ({url: row.website, title: row.website, targetBlank: true}), sortable: true },
                    { key: 'onboardDate', name: 'Onboard', width: 90, formatter: Formatter.Date, sortable: true },
                    { key: 'activationDate', name: 'Date Paid', width: 100, formatter: Formatter.Date, sortable: true },
                    { key: 'expirationDate', name: 'Expiration', width: 100, formatter: Formatter.Date, sortable: true },
                    { key: 'membershipLevel', name: 'Membership', sortable: true },
                    { key: 'membershipAmount', name: 'Membership Amount', width: 160, formatter: Formatter.Currency, sortable: true },
					{ key: 'paymentTerms', name: 'Payment Terms', sortable: false },
                    { key: 'pPofContact', name: 'PP of Contact', sortable: false },
                    { key: 'users', name: 'Users', sortable: false },
                    { key: 'active', name: 'Active', formatter: Formatter.Check, width: 50, cellClass: "text-center" }
                ]
            },
            tabs: [
                { key: "sponsorInfo", title: "Corporate Member Info", comp: SponsorInfoTab, helpKey: Help.sponsorSetupInfoHelpKey },
                { key: "sponsorUsers", title: "Users", comp: SponsorUsersTab, helpKey: Help.sponsorSetupUsersHelpKey },
                { key: "sponsorHistory", title: "Membership History", comp: SponsorHistoryTab, helpKey: Help.sponsorSetupHistoryHelpKey },
				{ key: "discountCodesHistory", title: "Certification Support History", comp: DiscountCodesHistoryTab, helpKey: Help.sponsorSetupHistoryHelpKey },
				{ key: "sponsorNotifications", title: "Notifications", comp: NotificationsTab, helpKey: Help.sponsorSetupNotificationsHelpKey },
                { key: "auditInfo", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.sponsorSetupInfoHelpKey }
            ]
        };

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}
export default SponsorSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/SponsorSetup.js